<template>
  <transition name="modal">
    <div class="modal-mask" @click="closeModal($event)">
      <div class="modal-wrapper" id="wrapper">
        <div class="modal-container">

          <transition name="expand">
            <div v-if="isLoading" class="App-confirm__event-card--loading">
              <h4>Loading...</h4>
              <p class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active" />
            </div>
          </transition>

          <div class="mdl-dialog__content" v-html="aboutText" />

          <transition name="expand">
            <div v-if="!isLoading">
              <div class="float-right">
                <button type="button" class="mdl-button mdl-button--accent" @click="closeModalButton('top')"><i class="material-icons">close</i> CLOSE</button>
              </div>
            </div>
          </transition>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    aboutText: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLoading() {
      return this.status === 0;
    },
    isError() {
      return this.status >= 400;
    }
  },
  methods: {
    // close modal if background is clicked
    closeModal(event) {
      if (event.target.id === 'wrapper') {
        this.$emit('close-modal');
      }
    },
    // Handle modal button closing
    closeModalButton() {
      this.$emit('close-modal');
    }
  },
  data() {
    return {};
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  overflow-y: scroll;
  overflow-x: hidden;

  width: 80vw;
  max-height: 100vw;
  margin: 0px auto;
  padding: 3%;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header {
  margin-top: 0;
  color: #42b983;
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.float-right {
  float: right;
}

/*
* the following styles are auto-applied to elements with
* v-transition="modal" when their visiblity is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter,
.modal-leave {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/AboutModal.vue